<div class="form-check" [formGroup]="formGroup">
  <input
    mdbCheckbox
    class="form-check-input"
    type="checkbox"
    value=""
    formControlName="{{controlName}}"
    id="{{id}}"
    [checked]="checked"
    />
  <label class="form-check-label" for="{{id}}">
    {{ label|translate }} @if (isRequiredTrue) {
    <span>*</span>
  }
</label>
@if (isRequiredTrue && control?.hasError('required') && (control?.dirty || control?.touched)) {
  <mdb-error
    style="top: 18px !important; left: 0 !important;">
    {{label|translate}} is required to be true
  </mdb-error>
}
</div>
